import theme from '@instructure/canvas-theme';

export default () => {
  window.Theme = theme
}
